import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import css from './ReportingActionsButton.css';
import MoreActionsPopover from '../../../../dataSources/components/MoreActionsPopover';
import { getActionComponentsConfigs } from '../../tableUtils';
import Tooltip from '../../../../components/molecules/Tooltip';
import Icon from '../../../../components/foundations/Icon';

export const REPORTING_ACTIONS_BUTTON_TEST_ID = 'reporting-actions-button';

const ReportingActionsButton = ({ translate, onDeleteClick, onEditClick }) => {
    const [showMenu, setShowMenu] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const actions = useMemo(() => getActionComponentsConfigs(onEditClick, onDeleteClick, translate), [
        onEditClick,
        onDeleteClick,
        translate,
    ]);

    const onOpen = event => {
        if (event.currentTarget === anchorEl) {
            setAnchorEl(null);
            setShowMenu(false);
            return;
        }
        setAnchorEl(event.currentTarget);
        setShowMenu(true);
    };

    const onClose = () => {
        setShowMenu(false);
        setAnchorEl(null);
    };

    return (
        <div>
            <Tooltip
                titleTranslationKey="STATIC.PAGES.AUDIENCES.AUDIENCE_AB_TESTING.REPORTING.MORE_ACTIONS"
                key="reporting-actions"
                wrapperClass={css.actionIcon}
            >
                <Icon
                    name="dots-vertical"
                    data-testid={REPORTING_ACTIONS_BUTTON_TEST_ID}
                    key="more_actions"
                    onClick={onOpen}
                />
            </Tooltip>
            {showMenu && (
                <div className={css.popoverComponent}>
                    <MoreActionsPopover
                        showExtendedMenu={showMenu}
                        onCloseExtendedMenu={onClose}
                        anchorEl={anchorEl}
                        actionComponentsConfigs={actions}
                        row={{}}
                    />
                </div>
            )}
        </div>
    );
};

ReportingActionsButton.propTypes = {
    translate: PropTypes.func,
    onEditClick: PropTypes.func,
    onDeleteClick: PropTypes.func,
};

export default withLocalize(ReportingActionsButton);
